export default __webpack_public_path__ + "static/lavacao-83b1a9c7c24eb3a47af6f92ae2b71b86.jpg";